import { LockOutlined } from '@mui/icons-material';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

/**
 * Shown in place of content the API refused, or that this user's restaurant rights do not cover.
 *
 * Deliberately calm rather than alarming: nothing here is broken and nothing the reader can do will
 * fix it. What it must not do is leave the space looking like data — an empty chart or a zero total
 * reads as "no sales today", which is a different and much worse claim than "you cannot see this".
 */
export const ForbiddenNote: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PermissionNote role="status">
      <LockOutlined fontSize="small" />
      <span>{t('permissions.noDataAccess')}</span>
    </PermissionNote>
  );
};

// Grey rather than red: a refusal is not a fault, and colouring it like one sends people looking for
// something to fix. It reads as a closed door, which is what it is.
const PermissionNote = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${({ theme }) => theme.spacing(1)} 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;
